import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, type OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-alert-modal',
  templateUrl: 'alert-modal.component.html',
  styleUrls: ['alert-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
      CommonModule
  ]
})
export class AlertModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() primaryButtonText?: string = 'App Support';
  @Output() primaryButtonClick: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modalCtrl: ModalController) {
    
  }

  ngOnInit(): void {}

  close() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  primaryAction() {
    // dismiss with primary role so callers can react (e.g., navigate to need-help)
    this.modalCtrl.dismiss(null, 'primary');
    this.primaryButtonClick.emit('click' as any);
  }
}

